/* unplugin-vue-components disabled */import SettingsIcon from './settings-icon.vue'

import {Rest} from 'utils'
import {SETTINGS_IP_WHITELIST} from 'consts/settings'
import {API_SETTINGS} from 'consts/api'

const __default__ = {
  data() {
    return {
      rest: new Rest(),
      loading: false,
      data: undefined,
      prev_data: undefined
    }
  },
  computed: {
    can_send() {
      return this.data !== this.prev_data
    }
  },
  async mounted() {
    // TODO: now we are using old python path, when ip whitelist will migrate to golang this setting gone
    try {
      const data = await this.rest.get(`${API_SETTINGS}/${SETTINGS_IP_WHITELIST}`)
      this.data = data || ''
      this.prev_data = this.data
      this.loading = false
    } catch (error) {
      if (!error.toString().includes('HTTP 404')) {
        throw error
      }
    }
  },
  methods: {
    async onSave() {
      this.loading = true
      try {
        if (!this.data) {
          await this.rest.delete(`${API_SETTINGS}/${SETTINGS_IP_WHITELIST}`)
        } else {
          await this.rest.put(API_SETTINGS, [{key: SETTINGS_IP_WHITELIST, value: this.data}])
        }
        $utils.toasts.message({
          message: 'Whitelist successfully applied',
          showImage: 'assets/check-circle-green.svg',
          class: 'success',
        })
        this.prev_data = this.data
      } catch (e) {
        $utils.toasts.error(e)
      }
      this.loading = false
    },
    onClear() {
      this.data = ''
      if (this.prev_data) this.onSave()
    }
  },
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'ip-whitelist',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { get Rest() { return Rest }, get SETTINGS_IP_WHITELIST() { return SETTINGS_IP_WHITELIST }, get API_SETTINGS() { return API_SETTINGS }, SettingsIcon }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})